module.exports = __webpack_public_path__ + "assets/8df6b6a7ae7f602108da0c20c4dc2646.mp3";